<template>
  <!-- Labels -->
  <div
    :class="$vuetify.breakpoint.xs ? 'ml-6' : 'ml-8'"
    @click="openLabelMenu($event)"
  >
    <div class="d-flex align-center">
      <div
        :class="$vuetify.breakpoint.xs ? 'font-size-10' : ''"
        class="font-weight-bold dark-purple-text graphik-font-size-14 d-flex align-center pointer"
      >
        <span
          :class="
            taskDetails && taskDetails.labels && taskDetails.labels.length
              ? 'd-none'
              : ''
          "
          class="mr-1"
        >
          Add New Label
        </span>

        <!-- Add Label Icon -->
        <v-tooltip color="#DCD8F3" bottom content-class="arrow-up">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="#2a206a"
              class="mb-1"
              size="18"
              v-on="on"
              v-bind="attrs"
            >
              mdi-plus-circle-outline
            </v-icon>
          </template>
          <span class="font-weight-bold dark-purple-text">Add New Label</span>
        </v-tooltip>
      </div>

      <!-- Labels Preview -->
      <span
        v-if="taskDetails && taskDetails.labels && taskDetails.labels.length"
      >
        <span v-for="(item, i) in taskDetails && taskDetails.labels" :key="i">
          <span
            v-show="
              getAllLabels &&
              getAllLabels.find((label) => {
                return label.id == item
              })
            "
          >
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              color="#DCD8F3"
              content-class="arrow-up"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  size="19"
                  class="pointer mb-1 ml-1"
                  v-bind="attrs"
                  v-on="on"
                  v-if="i < 4"
                  :color="
                    getAllLabels &&
                    getAllLabels.find((label) => {
                      return label.id == item
                    }) &&
                    getAllLabels.find((label) => {
                      return label.id == item
                    }).hexcode
                  "
                >
                  mdi-circle
                </v-icon>
              </template>
              <span class="font-weight-bold dark-purple-text caption">
                {{
                  getAllLabels &&
                  getAllLabels.find((label) => {
                    return label.id == item
                  }) &&
                  getAllLabels.find((label) => {
                    return label.id == item
                  }).title
                }}
              </span>
            </v-tooltip>
          </span>
        </span>
        <!-- If more than 5 chips -->
        <sub
          v-if="
            taskDetails &&
            taskDetails.labels &&
            taskDetails.labels.length &&
            taskDetails.labels.length > 4
          "
          class="pointer font-size-8 dusty-purple-text mx-1"
        >
          <span style="min-width: 30px;">
            (+{{ taskDetails.labels.length - 4 }} more)
          </span>
        </sub>
      </span>
    </div>
    <!-- Label Menu -->
    <v-menu
      v-model="labelMenu"
      :position-x="x"
      :position-y="y"
      offset-y
      content-class="bg-white shadow"
      min-width="264px"
      max-height="400px"
      :close-on-content-click="false"
    >
      <!-- Label List -->
      <div
        v-if="labelMenuView == 'list'"
        :class="[{ edited_scrollbar: isMac }]"
      >
        <div
          class="text-center dark-purple-text py-2 border-bottom font-weight-bold graphik-font-size-14"
        >
          Labels
        </div>
        <!-- Search field -->
        <div class="search-border rounded ma-2">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            background-color="white"
            placeholder="Search..."
            class="graphik-font-size-14"
            color="#757096"
            hide-details
            solo
            flat
            dense
            autofocus
            v-model="labelSearch"
            autocomplete="off"
            @keydown.enter="labelMenuView = 'create'"
          ></v-text-field>
        </div>
        <v-list
          class="pointer overflow-scroll px-3"
          scrollable
          max-height="260"
          :class="[{ edited_scrollbar: isMac }]"
        >
          <div class="my-2 d-flex" v-for="(item, i) in searchedLabels" :key="i">
            <div
              :style="`width: 200px; height: 32px; background-color:${item.hexcode}`"
              class="pointer rounded white--text px-3 text-capitalize d-flex align-center"
              @click="(addLabeltoList = true), updateLabel(item)"
            >
              <span
                class="text-truncate d-inline-block font-weight-bold font-size-14"
                style="max-width: 150px;"
              >
                {{ item.title ? item.title : '' }}
              </span>
              <v-spacer></v-spacer>
              <b>
                <v-icon
                  v-if="
                    taskDetails &&
                    taskDetails.labels &&
                    taskDetails.labels.find((label) => {
                      return label == item.id
                    })
                  "
                  small
                  color="white"
                >
                  mdi-check
                </v-icon>
              </b>
            </div>
            <div
              @click="
                ;(labelName = item.title),
                  ((labelMenuView = 'edit'), (labelSearch = null)),
                  (editLabel = item)
              "
              style="width: 32px;"
              class="pointer d-flex align-center justify-center ml-2 pointer edit-hover"
            >
              <img
                src="@/assets/images/light-purple-edit-icon.svg"
                alt="pencil"
                height="13px"
                width="13px"
              />
            </div>

            <img
              v-if="getSelectedCompany.role != 'employee'"
              @click="deleteLabel(item.id, taskDetails)"
              src="@/assets/images/cancel-icon.svg"
              alt="delete"
              height="13px"
              width="13px"
              class="pointer mt-3 edit-hover"
            />
          </div>
          <div v-if="labelSearch && searchedLabels && !searchedLabels.length">
            <p class="no-results-found my-1">No results found</p>
          </div>
        </v-list>
        <v-btn
          color="#EEF0F6"
          block
          tile
          depressed
          @click="(labelMenuView = 'create'),
              (labelName = null),
              (selectColor = null)
          "
          class="listing-hover text-capitalize dark-purple-text font-size-14"
        >
          <v-icon size="16" class="mx-1">mdi-plus</v-icon>
          <span>Create a New Label</span>
        </v-btn>
      </div>
      <!-- Create -->
      <div
        v-if="labelMenuView == 'create'"
        :class="[{ edited_scrollbar: isMac }]"
      >
        <div
          class="text-center dark-purple-text py-2 border-bottom font-weight-bold graphik-font-size-14"
        >
          Create Label
        </div>
        <div class="px-3 py-3">
          <!-- Label Name -->
          <div class="">
            <h5 class="dark-purple-text">Name</h5>
            <div class="theme-border rounded mt-2">
              <v-text-field
                background-color="white"
                placeholder="Label"
                class="graphik-font-size-14"
                color="#757096"
                hide-details
                solo
                flat
                dense
                autofocus
                v-model="labelSearch"
                autocomplete="off"
              ></v-text-field>
            </div>
          </div>
          <!-- Label Color -->
          <div class="mt-2">
            <h5 class="dark-purple-text">Select Color</h5>
            <div style="max-width: 240px;" class="mt-2">
              <v-chip
                v-for="(color, index) in labelColors"
                :key="index"
                label
                class="label-color-box ml-2 mb-2 px-2"
                :style="`background-color:${color}`"
                @click="selectColor = color"
              >
                <img
                  v-if="selectColor == color"
                  src="@/assets/images/white-tick-icon.svg"
                  alt="check"
                />
              </v-chip>
            </div>
          </div>
        </div>
        <!-- Create Button -->
        <v-btn
          class="text-capitalize"
          tile
          depressed
          color="#EEF0F6"
          block
          @click="createLabel(labelSearch, selectColor)"
        >
          <span class="dark-purple-text font-weight-bold font-size-14">
            Create
          </span>
        </v-btn>
      </div>
      <!-- Edit -->
      <div
        v-if="labelMenuView == 'edit'"
        :class="[{ edited_scrollbar: isMac }]"
      >
        <div
          class="text-center dark-purple-text py-2 border-bottom font-weight-bold graphik-font-size-14"
        >
          Edit Label
        </div>
        <div class="px-3 py-3">
          <!-- Label Name -->
          <div class="">
            <h5 class="dark-purple-text">Name</h5>
            <div class="theme-border rounded mt-2">
              <v-text-field
                background-color="white"
                placeholder="Checklist"
                class="graphik-font-size-14"
                color="#757096"
                hide-details
                solo
                flat
                dense
                autofocus
                v-model="labelName"
                autocomplete="off"
                @keydown.enter="updateLabelName(labelName, editLabel)"
              ></v-text-field>
            </div>
          </div>
          <!-- Label Color -->
          <div class="mt-2">
            <!-- <div style="max-width: 240px" class="mt-2"> -->
            <v-chip
              label
              class="px-2"
              :style="`background-color:${editLabel.hexcode};width:250px;border:rounded`"
            ></v-chip>
            <!-- </div> -->
          </div>
        </div>
        <!-- Save Button -->
        <v-btn
          class="text-capitalize"
          tile
          depressed
          color="#EEF0F6"
          block
          @click="updateLabelName(labelName, editLabel)"
        >
          <span class="dark-purple-text font-weight-bold font-size-14">
            Save
          </span>
        </v-btn>
      </div>
    </v-menu>
    <SnackbarNew
      :snackbar.sync="snackbar"
      :snackbarError="snackbarError"
      :snackbarMessage="snackbarMessage"
    />
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import { mapGetters } from 'vuex'
import { snackbarMixin } from '@/mixins/snackbarMixin'
export default {
  props: ['taskDetails'],
  mixins: [snackbarMixin],
  components: {
    SnackbarNew: () => import('@/components/Includes/SnackbarNew'),
  },
  data() {
    return {
      selectColor: null,
      labelMenu: false,
      labelSearch: null,
      createLabelMenu: false,
      editLabelMenu: false,
      labelName: null,
      addLabeltoList: false,
      editLabel: null,
      labelMenuView: 'list',
      x: null,
      y: null,
      labelColors: [
        "#2AA7E1",
        "#3F71F4",
        "#CC64D6",
        "#EFCF53",
        "#7BC2B2",
        "#6A4FF7",
        "#E9934A",
        "#C62852",
        "#DA539A",
        "#9FC929",
        "#8B979E",
        "#334563",
        "#1cc283",
        "#FFAC35",
      ],
    }
  },
  computed: {
    ...mapGetters(['getSelectedCompany', 'getLoggedInUser', 'getAllLabels', 'getView']),
    searchedLabels() {
      return this.getAllLabels && this.labelSearch
        ? this.getAllLabels.filter((item) => {
            return item.title
              ? item.title
                  .toLowerCase()
                  .includes(this.labelSearch.toLowerCase())
              : false
          })
        : this.getAllLabels
    },
  },
  methods: {
    openLabelMenu(event) {
      this.labelMenuView = 'list'
      this.x = event.clientX
      this.y = event.clientY
      this.labelSearch = null
      this.labelMenu = true
    },
    createLabel(label, color) {
      if (this.selectColor && this.labelSearch.trim()) {
        if (this.labelSearch && this.labelSearch.trim().length <= 50) {
          var existedLabel = this.getAllLabels.find((item) => {
            return (
              item.title.toLowerCase().trim() == label.toLowerCase().trim() &&
              item.hexcode == color
            )
          })
          if (
            existedLabel &&
            existedLabel.title.toLowerCase().trim() ==
              label.toLowerCase().trim() &&
            existedLabel.hexcode == color
          ) {
            this.openSnackbar(true, 'Label already exist')
          } else {
            let body = {
              company_id: this.getSelectedCompany.id,
              id: Date.now(),
              hexcode: color,
              title: label.trim(),
            }
            this.$store.commit('setCreateLabel', {
              id: body.id,
              hexcode: color,
              title: label.trim(),
            })
            this.labelMenuView = 'list'
            // this.createLabelMenu = false;
            // this.labelMenu = true;
            this.$store.dispatch('addLabel', body).then(() => {
              this.labelSearch = null
              this.selectColor = null
              this.openSnackbar(false, 'Label Added Successfully!')
            })
          }
        } else
          this.openSnackbar(
            true,
            'The title may not be greater than 50 characters',
          )
      } else this.openSnackbar(true, 'Add title and select color')
    },
    updateLabel(list) {
      if (
        (this.taskDetails &&
          this.taskDetails.assigned_by &&
          this.taskDetails.assigned_by.id == this.getLoggedInUser.id) ||
        this.getSelectedCompany.role != 'employee'
      ) {
        var add_label = false
        let body = {
          company_id: this.getSelectedCompany.id,
          task_id: this.taskDetails.task_id,
          labels:
            this.taskDetails &&
            this.taskDetails.labels &&
            this.taskDetails.labels.find((item) => {
              return item == list.id
            })
              ? this.taskDetails.labels.filter((item) => {
                  return item != list.id
                })
              : this.taskDetails &&
                this.taskDetails.labels &&
                this.taskDetails.labels.concat(list.id),
        }
        if (this.getView == 'list')
          this.$store.commit('setUpdatedTaskLabel', {
            task_id: this.taskDetails.task_id,
            label: list.id,
            add_label:
              this.taskDetails &&
              this.taskDetails.labels &&
              this.taskDetails.labels.find((item) => {
                return item == list.id
              })
                ? false
                : true,
          })
        else if (this.getView == 'kanban')
          this.$store.commit('setUpdatedTaskLabelKanban', {
            task_id: this.taskDetails.task_id,
            label: list.id,
            add_label:
              this.taskDetails &&
              this.taskDetails.labels &&
              this.taskDetails.labels.find((item) => {
                return item == list.id
              })
                ? false
                : true,
          })
        this.$store.dispatch('updateLabels', body).catch((error) => {
          this.openSnackbar(true, error.response.data.error_msg)
        })
      } else {
        this.openSnackbar(true, "Only creater can add/remove label")
      }
    },
    updateLabelName(labelName, editLabel) {
      if (this.labelName.trim() && this.labelName.trim().length <= 50) {
        var existedLabel = this.getAllLabels.find((item) => {
          return (
            item.title.toLowerCase().trim() == labelName.toLowerCase().trim() &&
            item.hexcode == editLabel.hexcode
          )
        })
        if (
          existedLabel &&
          existedLabel.title.toLowerCase().trim() ==
            labelName.toLowerCase().trim() &&
          existedLabel.hexcode == editLabel.hexcode
        ) {
          this.openSnackbar(true, 'Label already exist')
        } else {
          this.editLabelMenu = false
          this.$store.commit('setUpdateLabelName', {
            labelName: labelName.trim(),
            editLabel,
          })
          this.labelMenuView = 'list'
          this.$store
            .dispatch('updateLabelName', {
              id: editLabel.id,
              hexcode: editLabel.hexcode,
              title: labelName.trim(),
            })
            .catch((error) => {
              this.openSnackbar(true, 'Something went wrong')
            })
        }
      } else if (this.labelName && this.labelName.length > 50) {
        this.openSnackbar(
          true,
          'The title may not be greater than 50 characters',
        )
      } else if (!this.labelName) {
        this.openSnackbar(true, 'Label name is required')
      }
    },
    deleteLabel(labelId, taskDetails) {
      Swal.fire({
        title: 'Are you sure?',
        html: 'Delete Label!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'Delete',
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          let body = {
            label_id: labelId,
            company_id: this.getSelectedCompany.id,
            task_id: taskDetails.task_id,
          }
          this.$store
            .dispatch('deleteLabel', body)
            .then(() => {
              this.$store.commit('setDeleteTaskLabels', body)
              this.openSnackbar(false, 'Label Deleted Successfully')
            })
            .catch((error) => {
              this.openSnackbar(true, error.response.data.error_msg)
            })
        }
      })
    },
  },
}
</script>
<style scoped>
.label-color-box {
  min-height: 26px !important;
  min-width: 26px !important;
  max-height: 26px !important;
  max-width: 26px !important;
  border-radius: 3px;
}
.graphik-font-size-14 {
  font-family: "Graphik-Font-Family" !important;
  font-size: 14px;
}
.graphik-font-size-16 {
  font-family: "Graphik-Font-Family" !important;
  font-size: 16px;
}
</style>
